exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".transition_scale-leave{transform:scale(1)}.transition_scale-leave.transition_scale-leave-active{transition:transform .2s ease-in,height .15s ease-in-out;transform:scaleY(0)}.transition_scale-enter{transform:scaleY(0)}.transition_scale-enter.transition_scale-enter-active{transition:transform .2s ease-in,height .15s ease-in-out;transform:scale(1)}.transition_height-leave{max-height:8000px}.transition_height-leave.transition_height-leave-active{transition:max-height .2s ease-in;max-height:0}.transition_height-enter{max-height:0}.transition_height-enter.transition_height-enter-active{transition:max-height .2s ease-in;max-height:8000px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/styles/transitions.less
 ** module id = 501
 ** module chunks = 0
 **/